export const AUTH_STARTUP_TIMEOUT_MS = 15_000;

type AuthStartupGateInput = {
  isInitialLoading: boolean;
  hasUser: boolean;
  timedOut: boolean;
  hasTransientError: boolean;
};

export function getAuthStartupGateState({
  isInitialLoading,
  hasUser,
  timedOut,
  hasTransientError,
}: AuthStartupGateInput) {
  const loading =
    !hasUser && isInitialLoading && !timedOut && !hasTransientError;
  return {
    loading,
    showConnectionError:
      !hasUser && (hasTransientError || (isInitialLoading && timedOut)),
  };
}

export function scheduleAuthStartupTimeout(
  onTimeout: () => void,
  startedAt: number
): ReturnType<typeof setTimeout> {
  const remaining = Math.max(
    0,
    AUTH_STARTUP_TIMEOUT_MS - (Date.now() - startedAt)
  );
  return setTimeout(onTimeout, remaining);
}
